import React, { useState, useEffect } from 'react';

const Header = ({ theme, toggleTheme }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Simple function to just close the mobile menu
  const handleNavClick = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };
  
  return (
    <nav className={`nav ${scrolled ? 'scrolled' : ''}`} style={{
      background: scrolled 
        ? theme === 'light' ? 'rgba(245, 245, 245, 0.95)' : 'rgba(18, 18, 18, 0.95)'
        : theme === 'light' ? 'rgba(245, 245, 245, 0.8)' : 'rgba(18, 18, 18, 0.8)',
      boxShadow: scrolled ? '0 4px 20px rgba(0, 0, 0, 0.1)' : '0 2px 10px rgba(0, 0, 0, 0.2)'
    }}>
      <div className="nav-container">
        <a href="#intro" className="nav-brand" onClick={handleNavClick}>
          {theme === 'dark' ? 'ECD.' : 'ECD.'}
        </a>
        
        <button className="menu-toggle" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle navigation">
          <i className={`fas ${isOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
        
        <div className={`nav-links ${isOpen ? 'open' : ''}`}>
          <a href="#intro" onClick={handleNavClick}>Home</a>
          <a href="#about" onClick={handleNavClick}>About</a>
          <a href="#experience" onClick={handleNavClick}>Experience</a>
          <a href="#projects" onClick={handleNavClick}>Projects</a>
          <a href="#contact" onClick={handleNavClick}>Contact</a>
          <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle dark/light mode">
            <i className={`fas ${theme === 'light' ? 'fa-sun' : 'fa-moon'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Header; 